var barn_qb = {};
jQuery( document ).ready(function() {
  /* START barn custom quickbuy */
  /*
  Added to the Boost template (boost-pfs-html.liquid) as: <div class="barn-quickbuy"><script type="text/json"> {{itemVariants}} </script></div>
  {{itemVariants}} JSON data is built in (boost-pfs-filter.js)
  Also add variant data and generator code to boost-pfs-filter-product-item.liquid
  CALL: barn_qb.run() from (boost-pfs-filter.js) > Filter.prototype.afterRender and anywhere else you want to use this.

  CSS is in barn-quickbuy.css
  */
  barn_qb.run = function(){
    this.build_quick_buys();
    this.build_popup();
  }
  barn_qb.build_popup = function(){
    if (this.popup == undefined){
      let pop_html = "<div class='barn-quickbuy barn-quickbuy-popup'><div class='background-wrapper'></div><div class='quickbuy-wrapper'></div></div>";
      $('body').append(pop_html);
      this.popup = $('.barn-quickbuy-popup');

      //close events
      $('.background-wrapper').click(function(){ barn_qb.popup_close(); });
      $('.barn-quickbuy-popup').on('click', '.button', function() {
          barn_qb.popup_close();
      });
    }
  }
  barn_qb.mobile_click = function(target){
    //get the form wrapper
    let form_wrapper = $(target).prev();
    barn_qb.popup_launch(form_wrapper);

    //give me an active class
    $(target).closest('.barn-quickbuy').addClass('barn-quickbuy-opened');
    $('body').addClass('barn-quickbuy-opened');
  }
  barn_qb.popup_launch = function(obj){
    $(obj).clone().appendTo($('.quickbuy-wrapper'));
    this.popup_show();
  }
  barn_qb.popup_show = function(){
    this.popup.show();
  }
  barn_qb.popup_close = function(){
    this.popup.hide();
    $('.quickbuy-wrapper').empty();
    $('.barn-quickbuy-opened').removeClass('barn-quickbuy-opened');
  }
  barn_qb.build_quick_buys = function(){
    //find all the qbs 
    $('.barn-quickbuy:not(.js-qb)').each(function(i, obj) {
      let qele = $(obj).find('script[type="text/json"]');
      if(qele){
        try {
          let qdata = JSON.parse(qele.text());
          if(qdata.length > 0){
            let html = barn_qb.build_html(qdata);
            $(obj).append(html);
            $(obj).addClass('barn-quickbuy-desktop');
            $(obj).find('.mobile-wrapper').click(function(event){
              barn_qb.mobile_click(event.target);
            });
          }else{
            $(obj).addClass('qb-no-size-variants');
          }

        }catch(err){
          console.log('quickbuy json error');
        }
      }
      
      $(obj).find('.button').click(function() {
        //let variant = $(this).data('variant');
        let variant = $(this).attr("data-product-id");
        //console.log(variant);
        barn_qb.add_to_cart(variant);
      });
      
      
      $(obj).addClass('js-qb');
    });
  }
  barn_qb.build_html = function(data){
    let buttons_html = "";
    for(i=0;i<data.length;i++){
      buttons_html+= this.build_button(data[i]);
    }
    return "<div class='form-wrapper'><div class='title-wrapper' >Add your size to bag</div><div class='buttons-wrapper'>" + buttons_html + "</div></div><div class='mobile-wrapper'></div>";
  }
  barn_qb.build_button = function(data){
    if(data.name == undefined){ return ""; }
    var oos="";
    if(data.out_of_stock){ oos=" out-of-stock"; }
    //data values are picked up the cart.js
    return "<div data-add-to-cart data-product-id='"+data.id+"' class='button"+oos+"'>"+data.name+"</div>";
  }
  
  barn_qb.add_to_cart = function(variant_id){
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: variant_id
      },
      dataType: 'json', 
      success: function (data) { 
        $('#CartCount span:first').text(data.quantity);
        console.log(data.quantity);
      } 
    });
  }

  //RUN (used for PDP and other non AJAX loaded pages)
  barn_qb.run();
  
  /* END barn custom quickbuy */
});